import { createRoot } from 'react-dom/client'
import AppRoutes from './routes/reactdomroutes'
import { ThemeProvider, nwTheme } from '@nwh-consumer-digital/nw-component-lib'
import { Grid } from '@mui/material'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fal } from '@fortawesome/pro-light-svg-icons'
import './iformStyles.css'
import NorthwellHeader from './components/northwellheader/northwellheader'
import NorthwellLogo from './components/northwellheader/northwelllogoBar'
import ProgressBar from './components/northwellheader/progressindicator'
import { Footer } from '@nwh-consumer-digital/nw-component-lib'
import { ProgressProvider, useProgress } from './components/context/ProgressContext' // Import ProgressContext
import envConfig from './utils/configEnv/config'
import { ai } from './services/insights'
library.add(fal)

const defaultHeader = 'MyNorthwell minor consent form'

function App () {
  const { progressValue } = useProgress()

  // Initialize Application Insights if the key exists in config.
  const instrumentationKey = envConfig?.REACT_APP_APP_INSIGHTS_API_KEY
  if (instrumentationKey) {
    ai.initialize(instrumentationKey)
  }

  return (
    <ThemeProvider theme={nwTheme}>
      <Grid container direction='column' style={{ minHeight: '100vh' }}>
        <Grid item>
          <Grid container alignItems='center'>
            <Grid item xs={12}>
              <Grid
                container
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  flexGrow: 1,
                  height: '70px',
                  marginLeft: { xs: 0, sm: 'auto' },
                  marginRight: { xs: 0, sm: 'auto' },
                  maxWidth: '1140px',
                  paddingLeft: '30px',
                  paddingRight: '30px',
                  width: '100%',
                  justifyContent: { xs: 'center', sm: 'flex-start' }, // Center on mobile, left-align on larger screens
                }}>
                <NorthwellLogo />
              </Grid>
              <ProgressBar value={progressValue} />
            </Grid>
            <Grid item xs={12}>
              <NorthwellHeader formHeader={defaultHeader} />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          sx={{
            display: 'flex',
            flexGrow: 1,
            marginLeft: { xs: 0, sm: 'auto' },
            marginRight: { xs: 0, sm: 'auto' },
            maxWidth: '1140px',
            paddingLeft: '30px',
            paddingRight: '30px',
            paddingBottom: '100px',
          }}>
          <main style={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
            <AppRoutes />
          </main>
        </Grid>
        <Grid
          item
          style={{
            backgroundColor: '#34383c',
            display: 'flex',
            flexShrink: 0,
          }}>
          <Grid
            container
            style={{
              marginLeft: 'auto',
              marginRight: 'auto',
              maxWidth: '100%',
              width: '100%',
              padding: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            <Footer compact fullWidth='true' />
          </Grid>
        </Grid>
      </Grid>
    </ThemeProvider>
  )
}

export default App

const root = createRoot(document.getElementById('root'))
root.render(
  <ProgressProvider>
    <App />
  </ProgressProvider>,
)
